import { BUS_STATION_SELECTION_TYPE_ORIGIN } from '../components/BusBookingSearchForm/BusBookingSearchForm';
import { connect } from 'react-redux';
import BusBookingStationField from '../components/BusBookingSearchForm/BusBookingStationField';

const mapStateToProps = (state, { type }) => {
  const {
    origin,
    destination,
    bookOnBehalf,
    agentId,
  } = state.bus.bookingSearchForm;
  let value = 'Isi kota/terminal asal';
  let label = '';

  if (type === BUS_STATION_SELECTION_TYPE_ORIGIN) {
    label = 'Asal';

    value =
      origin && origin.searchFormLabel && origin.code
        ? origin.searchFormLabel
        : 'Isi kota/terminal asal';
  } else {
    label = 'Tujuan';
    value =
      destination && destination.searchFormLabel && destination.code
        ? destination.searchFormLabel
        : 'Isi kota/terminal tujuan';
  }

  return {
    label,
    value,
    disabled: bookOnBehalf && !agentId,
  };
};

export default connect(mapStateToProps)(BusBookingStationField);
